import React from "react";
import { Button, Checkbox, Segment } from "semantic-ui-react";

function BatchFormFooter({ genEstimate, setGenEstimate, disabled = false }) {
	return (
		<Segment textAlign="right" style={{ padding: 0 }} basic>
			<Checkbox
				checked={!!genEstimate}
				onClick={() => setGenEstimate(!!!genEstimate)}
				style={{
					marginRight: "25px",
					marginLeft: "15px",
				}}
				label="Generate Estimate?"
				toggle
			/>
			<Button type="submit" disabled={disabled} content="Sell" positive />
		</Segment>
	);
}

export default BatchFormFooter;
